module.exports = __webpack_public_path__ + "static/media/placeholder-group.ff374205.png";